import { render, staticRenderFns } from "./Associations.vue?vue&type=template&id=33060873&"
import script from "./Associations.vue?vue&type=script&lang=ts&"
export * from "./Associations.vue?vue&type=script&lang=ts&"
import style0 from "./Associations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports